import { filterTypesEnum } from '../components/FilterableList';
import {
  helpTextPlantPresentAccordingToModel,
  helpTextPlantPresentAccordingToUser,
} from './text';

export const beeFilters = {
  isRedList: {
    label: 'Rode lijst',
    filterType: filterTypesEnum.boolean,
    value: false,
  },
};

export const plantFilters = {
  isPresentAccordingToModel: {
    label: 'Gemodelleerd in jouw gebied',
    help: helpTextPlantPresentAccordingToModel,
    filterType: filterTypesEnum.boolean,
    value: true,
  },
  isNative: {
    label: 'Inheems',
    filterType: filterTypesEnum.boolean,
    value: false,
  },
};

export const plantFiltersAdvice = {
  isPresentAccordingToModel: {
    label: 'Gemodelleerd in jouw gebied',
    help: helpTextPlantPresentAccordingToModel,
    filterType: filterTypesEnum.boolean,
    value: true,
  },
  isPresentAccordingToUser: {
    label: 'Als reeds aanwezig aangeduid',
    help: helpTextPlantPresentAccordingToUser,
    filterType: filterTypesEnum.boolean,
    value: false,
  },
  isNative: {
    label: 'Inheems',
    filterType: filterTypesEnum.boolean,
    value: false,
  },
};
